// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file accounts/showcase_layout_type.proto (package protos.accounts, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file accounts/showcase_layout_type.proto.
 */
export const file_accounts_showcase_layout_type: GenFile = /*@__PURE__*/
  fileDesc("CiNhY2NvdW50cy9zaG93Y2FzZV9sYXlvdXRfdHlwZS5wcm90bxIPcHJvdG9zLmFjY291bnRzKs0BChJTaG93Y2FzZUxheW91dFR5cGUSIAocU0hPV0NBU0VfTEFZT1VUX1RZUEVfVU5LTk9XThAAEicKI1NIT1dDQVNFX0xBWU9VVF9UWVBFX1RIUkVFX0JZX1RIUkVFEAESJgoiU0hPV0NBU0VfTEFZT1VUX1RZUEVfVEhSRUVfVFdPX09ORRACEiMKH1NIT1dDQVNFX0xBWU9VVF9UWVBFX1RXT19CWV9UV08QAxIfChtTSE9XQ0FTRV9MQVlPVVRfVFlQRV9DVVNUT00QBGIGcHJvdG8z");

/**
 * @generated from enum protos.accounts.ShowcaseLayoutType
 */
export enum ShowcaseLayoutType {
  /**
   * @generated from enum value: SHOWCASE_LAYOUT_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: SHOWCASE_LAYOUT_TYPE_THREE_BY_THREE = 1;
   */
  THREE_BY_THREE = 1,

  /**
   * @generated from enum value: SHOWCASE_LAYOUT_TYPE_THREE_TWO_ONE = 2;
   */
  THREE_TWO_ONE = 2,

  /**
   * @generated from enum value: SHOWCASE_LAYOUT_TYPE_TWO_BY_TWO = 3;
   */
  TWO_BY_TWO = 3,

  /**
   * @generated from enum value: SHOWCASE_LAYOUT_TYPE_CUSTOM = 4;
   */
  CUSTOM = 4,
}

/**
 * Describes the enum protos.accounts.ShowcaseLayoutType.
 */
export const ShowcaseLayoutTypeSchema: GenEnum<ShowcaseLayoutType> = /*@__PURE__*/
  enumDesc(file_accounts_showcase_layout_type, 0);

